<template>
  <div id="bscpage1-view">
    <dv-full-screen-container>
      <div class="block-top-header">
        <div style="width: 40%">
          <top-header
            name="topHeader"
            :PageTitle="PageTitle"
            ActiveMenuIndex="bscpage2"
          />
        </div>
        <div style="width: 60%">
          <el-cascader
            id="selectedMonth"
            style="font-size: 22px; width: 350px"
            v-model="selectedMonth"
            :options="optionsmonth"
            :props="propsMonth"
            collapse-tags
            @change="refreshData()"
          ></el-cascader>

          <el-select
            v-model="selectedArea"
            style="right: -100px"
            class="block-top-button-field"
            placeholder
            @change="changedArea()"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="selectedBU"
            style="right: -150px"
            class="block-top-button-field"
            placeholder="All BUs"
            @change="changedBU()"
          >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="block-top-line"></div>

      <div class="main-content">
        <div class="block-top-bottom-content">
          <div class="block-top-button">
            <el-select
              v-model="selectedPlant"
              multiple
              placeholder="All Plants"
              style="width: 500px; margin-top: 10px"
              @change="refreshData()"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="block-top-mid">
            <bscbing1 ref="bscbing1Component" style="width: 40%"></bscbing1>
            <bscdown ref="bscdownComponent" style="width: 30%"></bscdown>
            <bscdown1 ref="bscdown1Component" style="width: 30%"></bscdown1>
          </div>
          <div class="block-top-content">
            <div class="block-top-content-1">
              <bscbo1 ref="bscbo1Component"></bscbo1>
              <bsczhu1
                ref="bsczhu1Component"
                style="visibility: hidden; display: none"
              ></bsczhu1>
            </div>
            <div class="block-top-content-2">
              <bscdown2 ref="bscdown2Component"></bscdown2>
            </div>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from "../TopMenu/topHeader.vue";
import bscbing1 from "./bscbing1";
import bscbo1 from "./bscbo1";
import bsczhu1 from "./bsczhu1";
import bscdown from "./bscdown";
import bscdown1 from "./bscdown1";
import bscdown2 from "./bscdown2";
import request from "@/utils/request";
import { AREA_LIST, BU_LIST } from "../mainPage/area_bu";

export default {
  name: "bscpage1",
  components: {
    topHeader,
    bscbing1,
    bscbo1,
    bsczhu1,
    bscdown,
    bscdown1,
    bscdown2,
  },
  data() {
    return {
      PageTitle: this.locale("Health of Plant", "工厂健康度"),
      options: AREA_LIST,
      options1: [],
      options2: BU_LIST,
      selectedBU: "",
      selectedPlant: "",
      selectedArea: "CN",
      selectedYear: "",
      selectedMonth: "",
      propsMonth: { multiple: false },
      optionsYear: [
        { value: "2019", label: "2019" },
        { value: "2020", label: "2020" },
      ],
    };
  },
  created() {
    this.optionsmonth = [];
    const iNowYear = new Date().getFullYear();
    for (let i = iNowYear; i > iNowYear - 5; i--) {
      let itemYear = {
        label: i,
        value: i,
      };
      this.optionsmonth.push(itemYear);
    }
    this.selectedMonth = [iNowYear];
  },
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
    const { refreshPlantList, refreshData } = this;

    this.optionsYear = [];
    const curYear = new Date().getFullYear();
    for (let i = 0; i <= 5; i++) {
      const valYear = curYear - i;
      this.optionsYear.push({ value: valYear, label: valYear });
    }
    this.GataTimeByData();
    // const iNowYear = (new Date()).getFullYear()
    // this.selectedMonth = [iNowYear]

    // refreshData();
  },
  methods: {
    GataTimeByData() {
      var par = {};
      //var strTime;
      request({
        url: "EnergySaving/GataTimeByData",
        method: "post",
        data: par,
      }).then((response) => {
        var vData = {};
        vData = response.data;
        console.log("输出1", vData);
        //this.strTime = [[Number(vData.Year) ,vData.Year+'-'+vData.Month]]
        // this.strTime = vData.Year;
        // this.strMonth = vData.Month;
        // console.log("输出2", this.strTime, this.strTime, this.strMonth);
        this.selectedMonth = [Number(vData.Year)];
        this.refreshData();
      });
    },
    changedArea() {
      const { refreshPlantList, refreshData } = this;

      refreshPlantList();
      refreshData();
    },
    changedBU() {
      const { refreshPlantList, refreshData } = this;

      refreshPlantList();
      refreshData();
    },
    refreshPlantList() {
      const queryArgs = {
        QueryAreaName: this.selectedArea,
        QueryBU: this.selectedBU,
      };

      request({
        url: "Kanban/PlantList",
        method: "post",
        data: queryArgs,
      }).then((response) => {
        const res = response;
        console.log(res);
        var vData = res.data.Data.PlantList;
        this.options1 = [];
        this.selectedPlant = "";
        for (var i = 0; i < vData.length; i++) {
          this.options1.push({
            value: vData[i].PlantCode,
            label: vData[i].PlantName,
          });
        }
      });
    },
    refreshData() {
      let selPlant = "";
      if (this.selectedPlant !== undefined && this.selectedPlant !== "") {
        selPlant = this.selectedPlant.join();
      }
      const queryArgs = {
        QueryAreaName: this.selectedArea,
        QueryBU: this.selectedBU,
        QueryPlantCode: selPlant,
        QueryYear: this.selectedMonth[0],
      };

      request({
        url: "Kanban/ProductionValueByMonth",
        method: "post",
        data: queryArgs,
      }).then((response) => {
        const res = response;
        console.log(res);
        var vData = res.data.Data.ProductionInfo["43"];
        this.$refs.bscbing1Component.refreshChart(vData);
        vData = res.data.Data.ProductionInfo["43"];
        this.$refs.bscbo1Component.refreshChart(vData);

        vData = res.data.Data.ProductionInfo["41"];
        this.$refs.bscdownComponent.refreshChart(vData);
        vData = res.data.Data.ProductionInfo["42"];
        this.$refs.bscdown1Component.refreshChart(vData);

        vData = res.data.Data.PlantHealth;
        this.$refs.bscdown2Component.refreshChart(vData);

        if (res.data.Data.ProductionInfo["41"] !== undefined) {
          vData = res.data.Data.ProductionInfo["41"];
          this.$refs.bsczhu1Component.refreshChart(vData);
        }
      });
    },
  },
};
</script>

<style lang="less">
#bscpage1-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;
  #dv-full-screen-container {
    background-image: url("");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .block-top-header {
    width: 100%;
    display: flex;
    background-color: #1b2445;
  }
  .block-top-line {
    //background-color: #1D2647;
    background-color: #313c5e;
    width: 100%;
    height: 4px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .block-top-button-field {
    background-color: #1b2445;
    margin-top: 15px;
    margin-left: 10px;
  }
  .block-top-button-field /deep/ .el-input__inner {
    background-color: #1b2445;
    color: #fff !important;
    font-size: 22px;
  }
  .block-top-button-content {
    flex: 1;
    height: 3%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-mid {
    height: 35%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content {
    height: 55%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content-1 {
    height: 100%;
    width: 40%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 0px;
  }
  .block-top-content-2 {
    height: 100%;
    width: 60%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-right: 20px;
    // padding-left: 20px;
  }
  .block-top-button {
    height: 5%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .el-select .el-input__inner {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    font-size: 22px;
  }
  .el-cascader .el-input__inner {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    color: #ffffff;
    font-size: 22px;
  }
  .el-cascader .el-cascader__tags .el-tag {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    color: #ffffff;
    font-size: 22px;
  }
}
</style>
